export const BARLOW_FONT = 'Barlow Semi Condensed Semibold';
export const FIGTREE_FONT = 'Figtree';
export const SPACE_GROTESK_FONT = 'Space Grotesk Bold';
